import { Injectable } from '@angular/core';

/**
 * Service gérant la configuration de la plateforme
 */
@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    config: any;

    setConfig(config: any) {
        this.config = config;
    }

    getConfig(): any {
        return this.config;
    }

    getEndPoint(): string {
        return this.config.endpoint.training.backend;
    }

    getFrontEndPoint(): string {
        return this.config.endpoint.training.front;
    }

    getConnectEndPoint(): string {
        return this.config.endpoint.connect.backend;
    }

    getRedirectEndPoint(): string {
        return this.config.endpoint.training.redirect;
    }

    getEasiSharedEndPoint(): string {
        return this.config.endpoint.shared.front;
    }

    /**
     * Origin of the easi-shared front-end (the header iframe host), for use as
     * a postMessage target origin and to validate `MessageEvent.origin` on
     * messages received from that iframe.
     *
     * @returns The easi-shared origin, or an empty string when the configured
     * endpoint is missing or unparsable (callers must then fail closed).
     */
    getEasiSharedOrigin(): string {
        try {
            return new URL(this.getEasiSharedEndPoint()).origin;
        } catch {
            return '';
        }
    }

    getReportFrontEndpoint(): string {
        return this.config.endpoint.report.front;
    }

    getReportOldFrontEndpoint(): string {
        return this.config.endpoint.report_old.front;
    }

    /**
     * URL of the learner-view introduction video (VA-08).
     *
     */
    getIntroVideoUrl(): string {
        return this.config.introVideoUrl;
    }
}
